import pp150px from "../assets/pp-150px.svg";
import pp150pxfull from "../assets/pp-wbody-150px.svg";


console.log(pp150px)
module.exports = {
  pp150px,
  pp150pxfull,
};
